// deviceSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  isMobile as detectIsMobile,
  isMobileOnly,
  isIOS,
  isIPad13,
} from "react-device-detect";

// 初期状態
const initialState = {
  isMobile: detectIsMobile, // react-device-detectから初期値を取得
  isIPhone: detectIsMobile && isIOS && !isIPad13, // iPhoneのみを判定（iPadを除外）
  // UA がスマホ（phone）か。タブレット（iPad / Android タブレット）は false。
  // 2 カラムレイアウト判定（useIsTwoColumn）で「スマホは横持ちで幅があっても
  // 1 カラム維持」とするために使う。isIPad13 は iPadOS 13+ がデスクトップ UA を
  // 名乗るケースの保険（isMobileOnly が誤判定しても iPad はスマホ扱いしない）。
  isPhone: isMobileOnly && !isIPad13,
  windowWidth: typeof window !== 'undefined' ? window.innerWidth : 0, // サーバーサイドレンダリング対応
};

const deviceSlice = createSlice({
  name: "device",
  initialState,
  reducers: {
    // モバイル状態を設定するアクション
    setIsMobile: (state, action) => {
      state.isMobile = action.payload;
    },
    // ウィンドウ幅を更新するアクション
    setWindowWidth: (state, action) => {
      state.windowWidth = action.payload;
      // 640pxをブレイクポイントとして使用（TwoColumnLayoutと一致させる）
      // この値はここで更新するが、isMobileの判定はreact-device-detectに任せる
    },
  },
});

// アクションクリエーターをエクスポート
export const { setIsMobile, setWindowWidth } = deviceSlice.actions;

// スライスのリデューサーをエクスポート
export default deviceSlice.reducer; 